import React from 'react';
import PropTypes from 'prop-types';
import { TextInput } from '@els/els-react--text-input';
import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';
import { possibleResults } from '../ForgotPasswordDialogConstants';

const spinnerId = 'resetPasswordForm';

function ForgotPasswordDialogContent({ requestSent, email, setEmail, isLoading, result, isEmailValid, trackAdobeAnalyticsError }) {
  const trackAdobeAnalyticsFormError = () => {
    if (!email && !isLoading) {
      trackAdobeAnalyticsError('Incorrect email address', 'fe-');
    }
  };

  if (result) {
    return (
      <section className="forgot-password-dialog__result">
        {result === possibleResults.success && (
          <span className="success-message u-els-color-text">
            Please check the inbox for
            <br /> <span className="u-els-font-family-bold u-els-color-text">{email}</span>
            <br /> for instructions to follow.
          </span>
        )}
        {result === possibleResults.emailInvalid && <span className="error-message">Invalid email</span>}
        {result === possibleResults.error && <span className="error-message">Server error</span>}
      </section>
    );
  }

  return (
    <>
      {isLoading && <SimpleSpinner id={spinnerId} />}
      <div className="forgot-password-dialog__text">
        <span className="u-els-font-size-base">
          Enter your email address below and we will send you an email with a link to create a new password
        </span>
      </div>

      <TextInput
        id="forgot-password-email"
        name="Email account"
        className="e2e-forgot-password-email-input u-els-margin-top-1x1o2"
        autoComplete="email"
        label="Email account"
        placeholder="Enter your email"
        data-e2e="forgot-password-email-input"
        required
        value={email}
        onChange={(e) => setEmail(e?.target?.value)}
        onBlur={trackAdobeAnalyticsFormError}
        disabled={isLoading}
        error={!isEmailValid && requestSent}
        errorMessage={!isEmailValid && requestSent ? 'Incorrect email address' : ''}
      />
    </>
  );
}

ForgotPasswordDialogContent.propTypes = {
  requestSent: PropTypes.bool,
  email: PropTypes.string,
  setEmail: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  result: PropTypes.string,
  isEmailValid: PropTypes.bool,
  trackAdobeAnalyticsError: PropTypes.func.isRequired,
};

export default ForgotPasswordDialogContent;
